import { HotWheelsCollection } from './hotwheels-collection';

export function HotWheelsCollectionPage() {
  return <HotWheelsCollection />;
}

export default HotWheelsCollectionPage;